import axios from 'axios';
import constants from "../constants";

const fetchRainTax = async () => {
  const rainTaxUrl = constants().URL_SERVICE + 'setting/rainTax/get_rain_tax';
  let result = await axios.get(rainTaxUrl);
  return result.data;
};

const setRainTax = async (data) => {
  const rainTaxUrl = constants().URL_SERVICE + 'setting/rainTax/set_rain_tax/';
  //const token = localStorage.getItem("auth_token");

  const config = {
    headers: { Authorization: "Token " + localStorage.token },
  };

  try {
    const response = await axios.post(rainTaxUrl, data, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export { fetchRainTax, setRainTax };


// WEBPACK FOOTER //
// ./src/services/rainTaxService.js